import { repository } from 'src/jtech/jtech-repository'

export const AgreementReportRepository = {
  nmInterfaceExportAgreement: 'agreementReport.agreementReport',
  nmInterfaceAgreementReportSearch: 'agreementReport.pesquisar',

  generateAgreementTable: async function () {
    return await repository.resolve(this.nmInterfaceAgreementReportSearch)
  },

  agreementReportSearchDatatable: async function () {
    return await repository.resolveDatatable(this.nmInterfaceAgreementReportSearch)
  },

  agreementReportSearch: async function (params) {
    return await repository.resolveDatatableModel(this.nmInterfaceAgreementReportSearch, params)
  },

  exportCsv: async function (params) {
    return await repository.resolveLogic(this.nmInterfaceExportAgreement, params)
  }
}
